const paintings5 = [
  {
    id: '5_01',
    name: 'A Garden Party',
    imageSrc: 'level5/5_01.jpg',
    cutSrc: 'level5/cut/5_01.jpg',
    author: 'HALS, Dirck',
    year: '1627',
  },
  {
    id: '5_02',
    name: 'Family Group in a Landscape',
    imageSrc: 'level5/5_02.jpg',
    cutSrc: 'level5/cut/5_02.jpg',
    author: 'HALS, Frans',
    year: 'c. 1648',
  },
  {
    id: '5_03',
    name: 'View of the Island of Capri',
    imageSrc: 'level5/5_03.jpg',
    cutSrc: 'level5/cut/5_03.jpg',
    author: 'HARPIGNIES, Henri-Joseph',
    year: '1853',
  },
  {
    id: '5_04',
    name: 'The Return from the War',
    imageSrc: 'level5/5_04.jpg',
    cutSrc: 'level5/cut/5_04.jpg',
    author: 'HARPIGNIES, Henri-Joseph',
    year: '1859',
  },
  {
    id: '5_05',
    name: 'River Landscape with a Village in the Background',
    imageSrc: 'level5/5_05.jpg',
    cutSrc: 'level5/cut/5_05.jpg',
    author: 'HARPIGNIES, Henri-Joseph',
    year: '1877',
  },
  {
    id: '5_06',
    name: 'River Banks, Auvergne',
    imageSrc: 'level5/5_06.jpg',
    cutSrc: 'level5/cut/5_06.jpg',
    author: 'HARPIGNIES, Henri-Joseph',
    year: '1860',
  },
  {
    id: '5_07',
    name: 'On Riviera',
    imageSrc: 'level5/5_07.jpg',
    cutSrc: 'level5/cut/5_07.jpg',
    author: 'HARPIGNIES, Henri-Joseph',
    year: '1891',
  },
  {
    id: '5_08',
    name: 'The Courtyard of the Customs House',
    imageSrc: 'level5/5_08.jpg',
    cutSrc: 'level5/cut/5_08.jpg',
    author: 'LÉPICIÉ, Nicolas-Bernard',
    year: '1775',
  },
  {
    id: '5_09',
    name: 'Still-Life',
    imageSrc: 'level5/5_09.jpg',
    cutSrc: 'level5/cut/5_09.jpg',
    author: 'HEEM, Jan Davidsz. de',
    year: '1653',
  },
  {
    id: '5_10',
    name: 'View from the Prater towards the Suburbs of Vienna',
    imageSrc: 'level5/5_10.jpg',
    cutSrc: 'level5/cut/5_10.jpg',
    author: 'HEIDELOFF, Josef',
    year: '1781',
  },
  {
    id: '5_11',
    name: 'The Bull Hunt in Campo San Polo',
    imageSrc: 'level5/5_11.jpg',
    cutSrc: 'level5/cut/5_11.jpg',
    author: 'HEINTZ, Joseph the Younger',
    year: '1648',
  },
  {
    id: '5_12',
    name: 'The Steeplechase',
    imageSrc: 'level5/5_12.jpg',
    cutSrc: 'level5/cut/5_12.jpg',
    author: 'HERRING, Benjamin Jr.',
    year: '1869',
  },
  {
    id: '5_13',
    name: 'The Entry of King Othon of Greece in Athens',
    imageSrc: 'level5/5_13.jpg',
    cutSrc: 'level5/cut/5_13.jpg',
    author: 'HESS, Peter von',
    year: '1839',
  },
  {
    id: '5_14',
    name: 'Landscape',
    imageSrc: 'level5/5_14.jpg',
    cutSrc: 'level5/cut/5_14.jpg',
    author: "HONDECOETER, Gillis Claesz. d'",
    year: '1620-22',
  },
  {
    id: '5_15',
    name: 'View of the Monastery of El Escorial',
    imageSrc: 'level5/5_15.jpg',
    cutSrc: 'level5/cut/5_15.jpg',
    author: 'HOUASSE, Michel-Ange',
    year: '1723',
  },
  {
    id: '5_16',
    name: 'The Grand Odalisque',
    imageSrc: 'level5/5_16.jpg',
    cutSrc: 'level5/cut/5_16.jpg',
    author: 'INGRES, Jean-Auguste-Dominique',
    year: '1814',
  },
  {
    id: '5_17',
    name: 'After a Storm',
    imageSrc: 'level5/5_17.jpg',
    cutSrc: 'level5/cut/5_17.jpg',
    author: 'ISABEY, Eugène',
    year: '1869',
  },
  {
    id: '5_18',
    name: 'View of La Iglesia y la Plaza de San Antonio, Aranjuez',
    imageSrc: 'level5/5_18.jpg',
    cutSrc: 'level5/cut/5_18.jpg',
    author: 'JOLI, Antonio',
    year: '1753-54',
  },
  {
    id: '5_19',
    name: 'Washington Crossing the Delaware',
    imageSrc: 'level5/5_19.jpg',
    cutSrc: 'level5/cut/5_19.jpg',
    author: 'LEUTZE, Emanuel Gottlieb',
    year: '1851',
  },
  {
    id: '5_20',
    name: 'The Royal Procession to the Church of Santa Maria di Piedigrotta',
    imageSrc: 'level5/5_20.jpg',
    cutSrc: 'level5/cut/5_20.jpg',
    author: 'JOLI, Antonio',
    year: 'c. 1770',
  },
  {
    id: '5_21',
    name: 'Landscape with Cephalus and Procris',
    imageSrc: 'level5/5_21.jpg',
    cutSrc: 'level5/cut/5_21.jpg',
    author: 'KEIRINCKX, Alexander',
    year: 'c. 1620',
  },
  {
    id: '5_22',
    name: 'Under the Birch Trees',
    imageSrc: 'level5/5_22.jpg',
    cutSrc: 'level5/cut/5_22.jpg',
    author: 'KLODT, Mikhail Konstantinovich',
    year: '1874',
  },
  {
    id: '5_23',
    name: "The Musicians' Brawl",
    imageSrc: 'level5/5_23.jpg',
    cutSrc: 'level5/cut/5_23.jpg',
    author: 'LA TOUR, Georges de',
    year: '1625-30',
  },
  {
    id: '5_24',
    name: 'Engagement between Sir George Brydges Rodney and the Spanish Squadron',
    imageSrc: 'level5/5_24.jpg',
    cutSrc: 'level5/cut/5_24.jpg',
    author: 'LUNY, Thomas',
    year: '1782',
  },
  {
    id: '5_25',
    name: "Rinaldo's Farewell to Armida",
    imageSrc: 'level5/5_25.jpg',
    cutSrc: 'level5/cut/5_25.jpg',
    author: 'LANFRANCO, Giovanni',
    year: '1614',
  },
  {
    id: '5_26',
    name: 'The Excommunication of Robert the Pious',
    imageSrc: 'level5/5_26.jpg',
    cutSrc: 'level5/cut/5_26.jpg',
    author: 'LAURENS, Jean-Paul',
    year: '1875',
  },
  {
    id: '5_27',
    name: 'Bacchanal',
    imageSrc: 'level5/5_27.jpg',
    cutSrc: 'level5/cut/5_27.jpg',
    author: 'LAURI, Filippo',
    year: '1675',
  },
  {
    id: '5_28',
    name: 'Venus and Adonis',
    imageSrc: 'level5/5_28.jpg',
    cutSrc: 'level5/cut/5_28.jpg',
    author: 'LAURI, Filippo',
    year: '1650s',
  },
  {
    id: '5_29',
    name: 'View of Florence from Villa San Firenze, near San Miniato',
    imageSrc: 'level5/5_29.jpg',
    cutSrc: 'level5/cut/5_29.jpg',
    author: 'LEAR, Edward',
    year: '1864',
  },
];

export default paintings5;
